import { render, staticRenderFns } from "./AppRealTimeReport.vue?vue&type=template&id=6b15612c&scoped=true&"
import script from "./AppRealTimeReport.vue?vue&type=script&lang=js&"
export * from "./AppRealTimeReport.vue?vue&type=script&lang=js&"
import style0 from "./AppRealTimeReport.vue?vue&type=style&index=0&id=6b15612c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b15612c",
  null
  
)

export default component.exports